function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Error message that can be expanded
 */
import React, { PureComponent } from 'react';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { vsTriangleRight, vsTriangleDown } from '@deephaven/icons';
import { assertNotNull } from '@deephaven/utils';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
class ConsoleHistoryResultErrorMessage extends PureComponent {
  constructor(props) {
    super(props);
    _defineProperty(this, "mouseX", void 0);
    _defineProperty(this, "mouseY", void 0);
    _defineProperty(this, "isClicking", void 0);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.handleMouseUp = this.handleMouseUp.bind(this);
    this.handleToggleError = this.handleToggleError.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.mouseX = null;
    this.mouseY = null;
    this.isClicking = false;
    this.state = {
      isExpanded: false,
      isTriggerHovered: false
    };
  }
  handleKeyPress(event) {
    switch (event.key) {
      case 'Enter':
      case ' ':
        // Toggle the error open/closed
        this.handleToggleError();
        event.stopPropagation();
        event.preventDefault();
        break;
      default:
        break;
    }
  }
  handleMouseDown(event) {
    this.mouseX = event.clientX;
    this.mouseY = event.clientY;
    this.isClicking = true;
  }
  handleMouseMove(event) {
    if (this.mouseX != null && this.mouseY != null) {
      if (Math.abs(event.clientX - this.mouseX) >= ConsoleHistoryResultErrorMessage.mouseDragThreshold || Math.abs(event.clientY - this.mouseY) >= ConsoleHistoryResultErrorMessage.mouseDragThreshold) {
        this.isClicking = false;
      }
    } else if (this.isClicking) {
      // Rare case - could happen if you mouse down, switch window focus, release the mouse, then come back, mouse down outside of the error, drag into the error, then release the mouse
      this.isClicking = false;
    }
  }
  handleMouseUp(event) {
    // We don't want to expand/collapse the error if user is holding shift or an alt key
    // They may be trying to adjust their selection
    if (this.isClicking && !event.shiftKey && !event.metaKey && !event.altKey) {
      this.handleToggleError();
    }
    this.mouseX = null;
    this.mouseY = null;
    this.isClicking = false;
  }
  handleToggleError() {
    this.setState(state => ({
      isExpanded: !state.isExpanded
    }));
  }
  handleMouseEnter() {
    this.setState({
      isTriggerHovered: true
    });
  }
  handleMouseLeave() {
    this.setState({
      isTriggerHovered: false
    });
  }
  render() {
    var _this$state = this.state,
      isExpanded = _this$state.isExpanded,
      isTriggerHovered = _this$state.isTriggerHovered;
    var messageProp = this.props.message;
    assertNotNull(messageProp);
    // Trim trailing whitespace to avoid unnecessary empty lines
    var message = messageProp.trimEnd();
    var lineBreakIndex = message.indexOf('\n');
    var isMultiline = lineBreakIndex > -1;
    var topLineOfMessage = message;
    if (isMultiline) {
      topLineOfMessage = message.slice(0, lineBreakIndex);
    }
    var remainderOfMessage = message.slice(lineBreakIndex);
    var arrowBtnClasses = isTriggerHovered ? 'error-btn-link error-btn-link--active' : 'error-btn-link';
    return /*#__PURE__*/_jsxs("div", {
      className: classNames('error-message', {
        expanded: isExpanded
      }),
      children: [isMultiline && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {
          className: "error-gutter",
          children: /*#__PURE__*/_jsx("button", {
            type: "button",
            onClick: this.handleToggleError,
            className: arrowBtnClasses,
            tabIndex: -1,
            children: /*#__PURE__*/_jsx(FontAwesomeIcon, {
              icon: isExpanded ? vsTriangleDown : vsTriangleRight,
              transform: "left-3"
            })
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "error-content",
          children: [/*#__PURE__*/_jsx("div", {
            className: "console-error-text-trigger",
            role: "button",
            tabIndex: 0,
            onKeyPress: this.handleKeyPress,
            onMouseDown: this.handleMouseDown,
            onMouseMove: this.handleMouseMove,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            onMouseUp: this.handleMouseUp,
            children: topLineOfMessage
          }), isExpanded ? remainderOfMessage : '']
        })]
      }), !isMultiline && /*#__PURE__*/_jsx("div", {
        className: "error-content",
        children: /*#__PURE__*/_jsx("div", {
          className: "console-error-text",
          children: topLineOfMessage
        })
      })]
    }, "error");
  }
}
_defineProperty(ConsoleHistoryResultErrorMessage, "defaultProps", {
  message: ''
});
_defineProperty(ConsoleHistoryResultErrorMessage, "mouseDragThreshold", 5);
export default ConsoleHistoryResultErrorMessage;
//# sourceMappingURL=ConsoleHistoryResultErrorMessage.js.map